import React from "react";
import { Button, Card, Row, Col } from "react-bootstrap";
import { walletprofile } from "../../constants/jsonConstant";
import Walletsidebar from "../../components/Wallet_sidebar";
import Timeline from "./Timeline/Timeline";
import ProfileSection from "./Timeline/Profilesection";
import "./style.css";
const WalletProfile = () => {
  return (
    <Row>
      <div className="screenHeight d-lg-flex justify-content-center align-items-center p-3">
        <Col
          lg="2"
          md="12"
          sm="12"
          xs="12"
          className="bg-white shadow-sm side---bar-h  rounded"
          style={{ border: "1px solid #0353a4" }}
        >
          <Walletsidebar />
        </Col>

        <Col lg="6" md="12" sm="12" xs="12" className="h-lg-100">
          <ProfileSection />
        </Col>

        <Col lg="4" md="12" sm="12" xs="12" className="h-lg-100">
          <Timeline />
        </Col>
      </div>
    </Row>
  );
};

export default WalletProfile;
